<template>
    <div></div>
</template>
<script>
     export default {
            name: "download",
            components: {},
            data() {
                return {
                }
            },
            beforeMount() {
                var userAgent = window.navigator.userAgent,
                platform = window.navigator.platform,
                macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
                windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
                iosPlatforms = ['iPhone', 'iPad', 'iPod','Mac OS X'],
                os = null;

                if (macosPlatforms.indexOf(platform) !== -1) {
                    os = 'Mac OS';
                } else if (iosPlatforms.indexOf(platform) !== -1) {
                    os = 'iOS';
                } else if (windowsPlatforms.indexOf(platform) !== -1) {
                    os = 'Windows';
                } else if (/Android/.test(userAgent)) {
                    os = 'Android';
                } else if (!os && /Linux/.test(platform)) {
                    os = 'Linux';
                }
                if(os=="Android"){
                    window.location.href="https://play.google.com/store/apps/details?id=tryhsk.com.app&hl=vi";
                }else if(os=="iOS"){
                    window.location="https://tryhsk.com";
                }else{
                    window.location="https://tryhsk.com";
                }
            }
        }
    </script>